import { mySource } from '@/assets/js/eventAnalyze.config.js'
export function mySourceAnalyze (str, path) {
  if (path != '/hm') return
  try {
    gtag('event', mySource[str]) // 谷歌统计
  } catch (err) {}
}
